import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import Page from '../../components/Page/Page';
import { SignInArea } from '../../sections/auth/SignInArea';

export default function SignIn() {
  return (
    <Page title="Darum | SignIn">
      <AuthLayout
        formHeaderTitle="Hello"
        formHeaderDescription="Sign in to your account"
        forgotPassword
      >
        <SignInArea />
      </AuthLayout>
    </Page>
  );
}
